/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Credit_Exhaustion_Upgrade_ProInputs */

const en_credit_exhaustion_upgrade_pro = /** @type {(inputs: Credit_Exhaustion_Upgrade_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade to Pro -- EUR 34.99/mo`)
};

const de_credit_exhaustion_upgrade_pro = /** @type {(inputs: Credit_Exhaustion_Upgrade_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Pro upgraden -- EUR 34,99/Monat`)
};

const fr_credit_exhaustion_upgrade_pro = /** @type {(inputs: Credit_Exhaustion_Upgrade_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passer à Pro -- EUR 34,99/mois`)
};

const es_credit_exhaustion_upgrade_pro = /** @type {(inputs: Credit_Exhaustion_Upgrade_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejorar a Pro -- EUR 34,99/mes`)
};

const it_credit_exhaustion_upgrade_pro = /** @type {(inputs: Credit_Exhaustion_Upgrade_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passa a Pro -- EUR 34,99/mese`)
};

const nl_credit_exhaustion_upgrade_pro = /** @type {(inputs: Credit_Exhaustion_Upgrade_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade naar Pro -- EUR 34,99/maand`)
};

const pl_credit_exhaustion_upgrade_pro = /** @type {(inputs: Credit_Exhaustion_Upgrade_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejdź na Pro -- EUR 34,99/mies.`)
};

const fi_credit_exhaustion_upgrade_pro = /** @type {(inputs: Credit_Exhaustion_Upgrade_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitä Pro -- EUR 34,99/kk`)
};

const da_credit_exhaustion_upgrade_pro = /** @type {(inputs: Credit_Exhaustion_Upgrade_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgrader til Pro — EUR 34,99/md`)
};

const sv_credit_exhaustion_upgrade_pro = /** @type {(inputs: Credit_Exhaustion_Upgrade_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppgradera till Pro -- EUR 34,99/mån`)
};

/**
* | output |
* | --- |
* | "Upgrade to Pro -- EUR 34.99/mo" |
*
* @param {Credit_Exhaustion_Upgrade_ProInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const credit_exhaustion_upgrade_pro = /** @type {((inputs?: Credit_Exhaustion_Upgrade_ProInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Credit_Exhaustion_Upgrade_ProInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_credit_exhaustion_upgrade_pro(inputs)
	if (locale === "fr") return fr_credit_exhaustion_upgrade_pro(inputs)
	if (locale === "es") return es_credit_exhaustion_upgrade_pro(inputs)
	if (locale === "it") return it_credit_exhaustion_upgrade_pro(inputs)
	if (locale === "nl") return nl_credit_exhaustion_upgrade_pro(inputs)
	if (locale === "pl") return pl_credit_exhaustion_upgrade_pro(inputs)
	if (locale === "fi") return fi_credit_exhaustion_upgrade_pro(inputs)
	if (locale === "da") return da_credit_exhaustion_upgrade_pro(inputs)
	if (locale === "sv") return sv_credit_exhaustion_upgrade_pro(inputs)
	return en_credit_exhaustion_upgrade_pro(inputs)
});